// @flow

import CheckboxFacet from './checkboxFacet';
import Facet from './facet';
import FacetsContainer from './facets.container';

export {
  CheckboxFacet,
  Facet,
};

export default FacetsContainer;
